import styled from 'styled-components';
import {Radio, Space} from 'antd'
import {bordersStyles} from '../../utils/styles';

const StyledRadioGroupIcon = styled(Radio.Group)`
  width: 100%;
`;

const StyledRadioSpace = styled(Space)`
  width: 100%;

  .ant-space-item {
    width: 100%;
  }

  label {
    ${bordersStyles.default};

    align-items: center;
    color: ${props => props.theme.colors.neutral_10};
    padding: 16px 0;
    display: flex;
    flex-direction: column;
    margin-inline-end: 0;
    position: relative;
    transition: .2s ease;

    .ant-space-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .icon {
      svg {
        width: 32px;
        height: 32px;
      }
    }

    // A badge icon (FilePdfBadgeIcon & co.) carries its own fixed colours -- scoping the monochrome
    // recolour rule itself to :not(.badge-icon) (rather than trying to cancel it afterward with
    // fill: unset) matters: fill is an inherited SVG property, so unset resolves to inherit -- from
    // the svg's own fill="none" root attribute -- which silently wiped every badge's own coloured
    // background rect (e.g. the PDF/XLS ribbon) to transparent. White ribbon text then had nothing
    // to contrast against and disappeared; ZIP's dark ribbon text stayed visible by accident.
    &:not(.badge-icon) .icon svg {
      path, rect {
        fill: ${props => props.theme.colors.neutral_6};
        transition: .2s ease;
      }
    }

    &.badge-icon {
      .icon svg {
        width: 40px;
        height: 40px;
      }
    }

    &.excel-icon {
      .icon {
        svg {
          path {
            &:nth-of-type(2) {
              fill: ${props => props.theme.colors.neutral_1};
            }
          }
        }
      }
    }

    .description {
      color: ${props => props.theme.colors.neutral_8};
      font-size: 12px;
      font-weight: 400;
      text-align: center;
    }

    &.ant-radio-wrapper-checked {
      border-color: ${props => props.theme.colors.primary_6};
      color: ${props => props.theme.colors.primary_6};
      font-weight: 500;

      &:not(.badge-icon) .icon svg {
        path, rect {
          fill: ${props => props.theme.colors.primary_6};
        }
      }
    }

    &:after {
      content: none;
    }

    > span {
      &:not(.ant-radio) {
        align-items: center;
        display: flex;
        flex-direction: column;
      }
      &.ant-radio {
        position: absolute;
        right: 8px;
        top: 8px;
      }
    }
  }
`;


export {
  StyledRadioGroupIcon,
  StyledRadioSpace
};
